import { forwardRef } from 'react';
import { ArrowLeft } from 'lucide-react';
import { cn } from '../../lib/cn';
import type { HeaderBackButtonProps } from './header-back-button.types';

export const HeaderBackButton = forwardRef<HTMLButtonElement, HeaderBackButtonProps>(
  ({ children, icon, className, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(
        '-ml-2 inline-flex items-center gap-1.5 rounded-md border-0 bg-transparent px-2 py-1 text-[12.5px] text-[var(--a-text-soft)] hover:bg-[var(--a-surface-2)] hover:text-[var(--a-text)]',
        className,
      )}
      {...props}
    >
      {icon ?? <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />}
      {children}
    </button>
  ),
);

HeaderBackButton.displayName = 'HeaderBackButton';
